module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SignCanvas', {
    ref: "SignCanvasRef",
    attrs: {
      "signName": _vm.nameList[_vm.nameIndex]
    },
    on: {
      "sureHandler": _vm.sureSignHandler
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68c549e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/index.vue
// module id = 507
// module chunks = 1